import { useState } from 'react';

import { Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { useDispatch } from 'react-redux';
import {
  resetView,
  resetViewsPanel,
  setCSVUploadEmployeeList,
  useViewsPanelState,
  useViewSubScreen,
  VIEWS_SUB_SCREENS,
} from 'reducers/viewsSlice';

import { Clone1 } from 'assets/assetsV1/iconComponents';

import { BottomDrawer, DrawerBody, DrawerContent, DrawerFooter, DrawerHeader } from 'uiToolkitV1/BottomDrawer';
import { ListItemComp } from 'uiToolkitV1/ListItemComp';

import { ApplyFiltersBody, SavePageBody } from '../components/ModalBody/ModalBody';
import { UploadCSVModalFooter } from '../components/ModalFooter/ModalFooter';
import { UploadEmployees } from '../components/uploadEmployees/UploadEmployees';
import { CloneViewFooter } from './CloneViewFooter';
import { CloneViewModal } from './CloneViewModal';

const StyledFlex = styled(Flex)`
  height: calc(100% - 8px);
  border: 4px solid ${(props) => props.theme.colors.neutral.EBEFF3};
  margin: 0 8px 8px 8px;
  border-radius: 8px;
`;

export const CloneView = () => {
  const { open } = useViewsPanelState();

  const viewsScreen = useViewSubScreen();

  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(resetViewsPanel());
    dispatch(resetView());
  };

  return (
    <BottomDrawer isOpen={open} onClose={onClose} placement="bottom">
      {viewsScreen === VIEWS_SUB_SCREENS.UPLOAD_CSV && <UploadCSVDrawerContent />}
      {viewsScreen !== VIEWS_SUB_SCREENS.UPLOAD_CSV && <CreateEditViewDrawerContent />}
    </BottomDrawer>
  );
};

const CreateEditViewDrawerContent = () => {
  const viewsScreen = useViewSubScreen();

  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(resetViewsPanel());
    dispatch(resetView());
  };

  return (
    <>
      <DrawerContent width="80%">
        <DrawerHeader onClose={onClose}>
          <ListItemComp title="Cloned View filters" LeftComponent={Clone1} withoutBackground padding="16px 24px" />
        </DrawerHeader>
        <DrawerBody>
          <StyledFlex>{viewsScreen === VIEWS_SUB_SCREENS.SAVE ? <SavePageBody /> : <ApplyFiltersBody />}</StyledFlex>
        </DrawerBody>
        <DrawerFooter>
          <CloneViewFooter />
        </DrawerFooter>
      </DrawerContent>
      <CloneViewModal />
    </>
  );
};

const UploadCSVDrawerContent = ({}) => {
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(resetViewsPanel());
    dispatch(resetView());
  };

  const [identifiedEmployeesData, setIdentifiedEmployeesData] = useState([]);
  const [nonIdentifiedEmployeesData, setNonIdentifiedEmployeesData] = useState([]);

  const onSaveHandler = () => {
    dispatch(setCSVUploadEmployeeList(identifiedEmployeesData));
  };

  return (
    <DrawerContent width="80%">
      <DrawerHeader onClose={onClose}>{/* <ModalHeader /> */}</DrawerHeader>
      <DrawerBody>
        <StyledFlex marginTop="8px !important" height="calc(100% - 16px) !important">
          <UploadEmployees
            setIdentifiedEmployeesData={setIdentifiedEmployeesData}
            setNonIdentifiedEmployeesData={setNonIdentifiedEmployeesData}
            nonIdentifiedEmployeesData={nonIdentifiedEmployeesData}
            identifiedEmployeesData={identifiedEmployeesData}
          />
        </StyledFlex>
      </DrawerBody>
      <DrawerFooter>
        <UploadCSVModalFooter onSaveHandler={onSaveHandler} />
      </DrawerFooter>
    </DrawerContent>
  );
};
